/**
 * Resolves the `?delivery_week=` query override (Task 15: week preview) to a
 * previewable week code, or null.
 *
 * Pure and DOM-free so it's require()-able in node:test, mirroring
 * assets/delivery-allowed-weeks.js. The caller (assets/availability-filter.js) owns
 * every browser-coupled bit: reading window.location.search via URLSearchParams (whose
 * .get() already turns the `+` in `?delivery_week=DS+2635` into a real space -- this
 * function is handed that already-decoded string and does no decoding of its own),
 * and supplying the live window.StockedDeliveryFormat.parseWeekCode /
 * window.StockedDelivery.selectableWeeks() this runs against.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.StockedDeliveryWeekPreview = api;
})(typeof self !== 'undefined' ? self : this, function () {
  // `raw` is the already-decoded query value (or null/undefined if the param was
  // absent). Validates in two steps, both required: parseWeekCode() alone only checks
  // SYNTAX, not whether the storefront can currently offer that week -- a syntactically
  // valid code outside `selectableWeeks` is still ignored, since previewing a week the
  // horizon doesn't offer would show a misleading result. There is no default to fall
  // back to: anything that fails either check yields null, and normal (non-preview)
  // behaviour resumes.
  function resolvePreviewWeek(raw, selectableWeeks, parseWeekCode) {
    if (typeof raw !== 'string') return null;
    var code = raw.trim();
    if (!code) return null;
    if (typeof parseWeekCode !== 'function' || !parseWeekCode(code)) return null;
    var weeks = Array.isArray(selectableWeeks) ? selectableWeeks : [];
    return weeks.indexOf(code) === -1 ? null : code;
  }

  return { resolvePreviewWeek: resolvePreviewWeek };
});
